// extracted by css-extract-rspack-plugin
export default {"root":"m6mas","menu":"f4fXp","noResults":"anv6L","name":"VF087","clickable":"UiL2N","selected":"DIUoG","actionIcon":"SGSkR"};